import styled from 'styled-components'
import { ResponsiveImage } from '../ResponsiveImage/ResponsiveImage'

export const BannerWrapper = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: start;
`

export const Link = styled.a`
  width: 100%;
  &:hover,
  &:link,
  &:visited,
  &:active {
    text-decoration: none;
  }
`

interface BannerContentProps {
  $loading?: boolean
  color?: string
}

export const BannerContent = styled.div<BannerContentProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem;
  max-width: 33rem;
  margin: 0 auto 30% auto;

  background: ${({ theme }) => theme.colors.background};
  box-shadow: ${({ $loading, theme, color }) => {
    return `10px 10px 0px 5px ${
      $loading ? theme.colors.skeleton.baseColor : color ?? theme.colors.primary
    }`
  }};
`

export const Title = styled.h2`
  width: 100%;
  margin: 1.5rem 0 0.5rem 0;
  text-align: center;
  font-size: 2rem;
  font-family: ${({ theme }) => theme.fonts.brand};
  font-weight: 600;
  color: ${({ theme, color }) => color ?? theme.colors.primary};
  text-transform: uppercase;
`

export const Description = styled.p`
  width: 100%;
  margin: 0.5rem 0.5rem 1.5rem 0.5rem;
  font-family: ${({ theme }) => theme.fonts.brand};
  font-size: 1.8rem;
  line-height: 2.9rem;
  color: ${({ theme }) => theme.colors.text.primary};
  text-align: center;
`

export const ImgContainer = styled.div`
  width: 100%;
  aspect-ratio: 1;
`

export const Img = styled(ResponsiveImage)`
  display: none; // Non sappiamo se la squared banner image esiste, quindi meglio nascondere di default l'immagine
  object-fit: cover;
  aspect-ratio: 1;
  width: 100%;
`
